var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"body-2",attrs:{"value":_vm.initialName,"rules":[(v) => !!v || _vm.$t('field-requied')],"label":_vm.$t('experiment-name'),"prepend-inner-icon":_vm.mdiFileOutline,"name":"name","placeholder":" ","outlined":"","validate-on-blur":"","required":""},on:{"change":function($event){return _vm.$emit('attrUpdate', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }